import { AppRouter } from './routes/router'

const App = () => {
  return <AppRouter />
}

export default App
